<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'PredefineGroupList' }"
              ><i class="fas fa-chevron-left"></i>
              </router-link>
              Predefined Group
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Predefined Group</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="PredefineGroup">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt=""/>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">

                  <div class="form-group">
                    <label class="control-label">Group Name</label>
                    <input
                      type="text"
                      id="group_name"
                      name="group name"
                      v-validate="'required'"
                      v-bind:class="{ 'has-error': errors.has('group_name') }"
                      v-model="value.group_name"
                      class="form-control group_name"

                      placeholder="Group Name"
                    />
                    <div class="help text-danger" v-show="errors.has('group name')">
                      {{ errors.first("group name") }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Display Name</label>
                    <input
                      type="text"
                      id="display_name"
                      name="display_name"
                      v-validate="'required'"
                      v-bind:class="{ 'has-error': errors.has('display_name') }"
                      v-model="value.display_name"
                      class="form-control display_name"
                      placeholder="Display Name"
                    />
                    <div class="help text-danger" v-show="errors.has('display_name')">
                      {{ errors.first("display_name") }}
                    </div>
                  </div>
                  <!-- <div class="form-group">
                    <label class="control-label">Site Type</label>
                    <input
                      type="text"
                      id="site_type"
                      name="site_type"
                      v-validate="'required'"
                      v-bind:class="{ 'has-error': errors.has('site_type') }"
                      v-model="value.site_type"
                      class="form-control site_type"
                      placeholder="Site Type"
                    />
                    <div class="help text-danger" v-show="errors.has('site_type')">
                      {{ errors.first("site_type")}}
                    </div>
                  </div> -->
                      <div class="form-group">
                    <label class="control-label">Icon</label>
                    <input
                      type="text"
                      id="icon"
                      name="display_name"
                      v-validate="'required'"
                      v-bind:class="{ 'has-error': errors.has('group_icon') }"
                      v-model="value.group_icon"
                      class="form-control group_icon"
                      placeholder="Icon"
                    />
                    <div class="help text-danger" v-show="errors.has('group_icon')">
                      {{ errors.first("group_icon") }}
                    </div>
                  </div>
                      <div class="form-group ">
                    <label class="control-label">Site Type</label>
                    <multiselect v-model="value.site_type" :options="pre.site_type" placeholder="Select Type"
                                 :searchable="true"
                                 :multiple="false" id="site_type" v-bind:class="{ 'has-error': errors.has('site_type') }"
                                 name="site_type"
                                v-validate="'required'"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('site_type')">
                      {{ errors.first("site_type") }}
                    </div>
                  </div>


                  <div class="form-group ">
                    <label class="control-label">Priority</label>
                    <input
                      type="number"
                      id="priority"
                      name="priority"
                      v-validate="'required|numeric|between:0,9'"
                      v-bind:class="{ 'has-error': errors.has('priority') }"
                      v-model="value.priority"
                      class="form-control priority"
                      placeholder="Priority"
                    />
                    <div class="help text-danger" v-show="errors.has('priority')">
                      {{ errors.first("priority") }}
                    </div>
                  </div>

<!-- 
                  <div class="form-group required">
                    <label for="icon" class="control-label">Icon</label>
                    <vfa-picker :only="['solid']" v-model="value.group_icon">
                      <template v-slot:activator="{ on }">
                        <input id="group_icon" v-model="value.group_icon" @click="on" placeholder="Icon Class"
                               type="text"/>
                      </template>
                    </vfa-picker>

                    <div class="help text-danger" v-show="errors.has('group_icon')">
                      {{ errors.first("group_icon") }}
                    </div>
                  </div> -->


                  <div class="form-group " v-if="is_edit">
                    <label class="control-label">Synchronas Update</label>
                    <multiselect v-model="value.synchronas_update" :options="pre.check" placeholder="Select Type"
                                 :searchable="true"
                                 :multiple="false" id="check" v-bind:class="{ 'has-error': errors.has('synchronas_update') }"
                                 name="type"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('synchronas_update')">
                      {{ errors.first("synchronas_update") }}
                    </div>
                  </div>


                  <div class="form-group">
                    <label class="control-label">Content</label>
                    <input
                      v-model="contentInput"
                      @keydown.enter.prevent="addContent"
                      class="form-control content mb-3"
                      placeholder="Press 'Enter' to add a content"
                      id="content"
                    />
                    <div class="mt-2 d-flex" style="flex-wrap: wrap">
                      <div v-for="(content, index) in contents" :key="index" class="mr-2 mb-2">
                        <span @click="removeContent(index)" class="checkbox-block checkbox-block-box">
                          {{ content }} <i class="icon-close"></i>
                        </span>
                      </div>

                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {CommonAPI} from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";

export default {
  name: "PredefinedGroupForm",
  metaInfo: {
    title: "Predefined Group | Dotlines",
  },
  components: {},

  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    value: {
      synchronas_update: 'no'
    },

    pre: {
      audraName: [],
      check: ['yes', 'no'],
      site_type: ['SITE','CATEGORY']
    },
    contents: [],
    contentInput: ''
  }),
  watch: {},
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          _this.processContent();

          let api_url = "/predefine_groups";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/predefine_groups/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({name: "PredefineGroupList"});
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/predefine_groups/" + id;
        axios
          .get(api_url, {
            params: {accountId: LocalStorage.get('accountId')}
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
            this.extractContents()
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          });
      }

      this.value.accountId = LocalStorage.get("accountId");
      this.is_loading = false;
    },
    addContent() {
      if (this.contentInput.trim() !== '') {
        this.contents.push(this.contentInput.trim());
        this.contentInput = '';
      }
    },
    removeContent(index) {
      this.contents.splice(index, 1);
    },

    processContent() {
      this.value.content = '%' + this.contents[0];
      for (let i = 1; i < this.contents.length; i++) {
        this.value.content += '%\r\n%' + this.contents[i].toLowerCase()
      }

      this.value.content += '%'
    },
    extractContents() {
      const content = this.value.content.substring(1, this.value.content.length - 1)
      this.contents = content.split('%\r\n%').filter(segment => segment !== '');
    }

  },
  mounted() {
    this.initialize();
  },
};
</script>
